/**
 * Frontend mirror of NrgMetrics.Services.Companies.CompanyExportColumns.All.
 * Keep ids and headers in sync — the backend resolves selection by id.
 */
export interface ExportColumnDef {
  id: string;
  group: string;
  header: string;
  /** True by default when the picker opens (matches the previous Companies-list export shape, minus the removed columns). */
  defaultSelected: boolean;
}

export const COMPANY_EXPORT_COLUMN_GROUPS: ReadonlyArray<string> = [
  'Identity',
  'Sector',
  'Stock Indexes',
  'Founding',
  'Capitalization',
  'Reports',
  'Deregistration'
];

export const COMPANY_EXPORT_COLUMNS: ReadonlyArray<ExportColumnDef> = [
  // Identity
  { id: 'internalId', group: 'Identity', header: 'Internal ID', defaultSelected: true },
  { id: 'name', group: 'Identity', header: 'Name', defaultSelected: true },
  { id: 'year', group: 'Identity', header: 'Year', defaultSelected: true },
  { id: 'country', group: 'Identity', header: 'Country', defaultSelected: true },
  { id: 'isin', group: 'Identity', header: 'ISIN', defaultSelected: true },

  // Sector
  { id: 'industry', group: 'Sector', header: 'Industry', defaultSelected: true },
  { id: 'superSector', group: 'Sector', header: 'Super Sector', defaultSelected: true },
  { id: 'sector', group: 'Sector', header: 'Sector', defaultSelected: true },
  { id: 'subSector', group: 'Sector', header: 'Sub Sector', defaultSelected: true },

  // Stock Indexes
  { id: 'index1', group: 'Stock Indexes', header: 'Index 1', defaultSelected: true },
  { id: 'index2', group: 'Stock Indexes', header: 'Index 2', defaultSelected: true },
  { id: 'index3', group: 'Stock Indexes', header: 'Index 3', defaultSelected: true },

  // Founding
  { id: 'yearOfFounding', group: 'Founding', header: 'Year of Founding', defaultSelected: true },
  { id: 'yearWentPublic', group: 'Founding', header: 'Year Went Public', defaultSelected: true },

  // Capitalization
  { id: 'capitalization', group: 'Capitalization', header: 'Capitalization', defaultSelected: false },

  // Reports
  { id: 'linkToAnnualReport', group: 'Reports', header: 'Link to Annual Report', defaultSelected: false },
  { id: 'yearEnd', group: 'Reports', header: 'Year End', defaultSelected: false },
  { id: 'annualReportPublicationDate', group: 'Reports', header: 'Publication Date A.R.', defaultSelected: false },
  { id: 'csrReportPublicationDate', group: 'Reports', header: 'Publication Date ESG', defaultSelected: false },
  { id: 'hasAnnualReport', group: 'Reports', header: 'A.R.', defaultSelected: false },
  { id: 'hasCorporateGovernanceReport', group: 'Reports', header: 'C.G.R.', defaultSelected: false },
  { id: 'hasProxyStatement', group: 'Reports', header: 'Proxy', defaultSelected: false },
  { id: 'hasForm20F', group: 'Reports', header: '20F', defaultSelected: false },
  { id: 'hasFinancialReport', group: 'Reports', header: 'Fin. Rep.', defaultSelected: false },
  { id: 'hasCsrReport', group: 'Reports', header: 'ESG', defaultSelected: false },
  { id: 'hasCsrReportInAnnualReport', group: 'Reports', header: 'ESG in A.R.', defaultSelected: false },
  { id: 'csrOther', group: 'Reports', header: 'ESG Other', defaultSelected: false },
  { id: 'terms', group: 'Reports', header: 'Terms', defaultSelected: false },
  { id: 'comments', group: 'Reports', header: 'Comments', defaultSelected: false },

  // Deregistration
  { id: 'deregistrationDate', group: 'Deregistration', header: 'Deregistration Date', defaultSelected: false },
  { id: 'deregistrationReason', group: 'Deregistration', header: 'Deregistration Reason', defaultSelected: false },
  { id: 'deregistrationDescription', group: 'Deregistration', header: 'Deregistration Description', defaultSelected: false }
];
